import { z } from 'zod';
import { createBusinessContext } from './functions/createBusinessContext';
/**
 * PublicContext will not be added to businessContextList because it behaves a bit different and is not part of the secure viewport in portal-home
 */
export const PublicContext = createBusinessContext('public', {
    path: '/public',
    schema: z.object({}),
});
export const MortgageContext = createBusinessContext('mortgages', {
    path: '/mortgages/:id',
    schema: z.object({ id: z.string() }),
});
export const ConsumerCreditContext = createBusinessContext('consumer-credits', {
    path: '/consumer-credits/:id',
    schema: z.object({ id: z.string() }),
});
export const SubmissionContext = createBusinessContext('submissions', {
    path: '/submissions/:id',
    schema: z.object({ id: z.string() }),
});
export const InsuranceContext = createBusinessContext('insurance', {
    path: '/insurance/:id',
    schema: z.object({ id: z.string() }),
});
export const OrganizationContext = createBusinessContext('organization', {
    path: '/organization/:type/:id',
    schema: z.object({ type: z.enum(['users', 'units', 'companies']), id: z.string() }),
});
/**
 * List of all context which are available
 */
export const businessContextList = [
    MortgageContext,
    ConsumerCreditContext,
    SubmissionContext,
    // InsuranceContext, // todo: check if insurance should be added here
    OrganizationContext,
];
